import { motion } from "framer-motion";
import { GALLERY } from "@/lib/data";
import SectionHeading from "@/components/SectionHeading";

export default function Gallery() {
  return (
    <div data-testid="gallery-page">
      <section className="relative pt-32 pb-12 md:pt-40 md:pb-16 overflow-hidden">
        <div className="absolute inset-0 grid-bg opacity-60" />
        <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[900px] h-[500px] radial-glow-red pointer-events-none" />

        <div className="relative max-w-6xl mx-auto px-6 lg:px-10">
          <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.28em] text-red-500 mb-4 font-mono-brand">
            <span className="w-8 h-px bg-current" /> Gallery
          </div>
          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-black tracking-tighter leading-[1.05] text-white">
            Moments from the road
          </h1>
          <p className="mt-6 text-lg text-slate-400 max-w-3xl leading-relaxed">
            Vehicle deliveries, handovers, fleet line-ups, and the team behind Be Easy Cars.
          </p>
        </div>
      </section>

      <section className="py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {GALLERY.map((g, i) => (
            <motion.figure
              key={g.url}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i % 4) * 0.06 }}
              className="group relative overflow-hidden rounded-2xl border border-white/10 aspect-[4/5] bg-slate-900"
              data-testid={`gallery-item-${i}`}
            >
              <img
                src={g.url}
                alt={g.label}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-90" />
              <figcaption className="absolute bottom-3 left-4 right-4 text-white text-xs uppercase tracking-widest font-mono-brand">
                {g.label}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </section>
    </div>
  );
}
